import IconStar from "./star.svg?react";
import { Trans } from "react-i18next";
import "./index.scss";

interface VideoAnalysisPanelProps {
  data: any;
  isTrans?: boolean;
}

const VideoAnalysisPanel = ({ data, isTrans }: VideoAnalysisPanelProps) => {
  return (
    <div className="relative rounded-[12px] bg-kds-bg p-[24px] flex-1">
      <div className="flex items-center gap-[4px] mb-[4px]">
        <IconStar />
        <div className="font-semibold text-[16px] text-kds-fg flex items-center">
          <Trans>Key to Success</Trans>
        </div>
      </div>
      <div className="text-[14px] text-kds-fg leading-[22px] mb-[12px]">
        {(isTrans ? data.translate_key_to_success_list : data.key_to_success_list)?.map((item: any) => (
          <div key={item}>{item}</div>
        ))}
      </div>

      <div className="flex items-center gap-[4px] mb-[4px]">
        <IconStar />
        <div className="font-semibold text-[16px] text-kds-fg flex items-center">
          <Trans>Camera Work</Trans>
        </div>
      </div>
      <div className="text-[14px] text-kds-fg leading-[22px]">
        {isTrans ? data.translate_camera_work : data.camera_work}
      </div>
    </div>
  );
};

export default VideoAnalysisPanel;
